module.exports = __webpack_public_path__ + "static/media/ProvenAndLoveland.55daa4b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/img/ProvenAndLoveland.svg
// module id = 952
// module chunks = 0